import React, { FC } from 'react';
import { AccessTime } from '@mui/icons-material';
import { noop } from 'lodash';
import { openEntityHistoryDialog, EntityType, FieldType } from 'store/EntityHistory';

interface ViewHistoryToolbarButtonProps {
	onClick?: () => void;
	disabled?: boolean;
	entityType?: string;
	entityId?: number;
	fieldType?: FieldType;
}

export const ViewHistoryToolbarButton: FC<ViewHistoryToolbarButtonProps> = ({
  onClick = noop,
  disabled = false,
  entityType,
  entityId,
  fieldType = 'title',
}) => {

  const handleClick = () => {
    if (entityType && entityId) {
      openEntityHistoryDialog(entityType as EntityType, entityId, fieldType);
      onClick();
    }
  };

  return (
    <div onClick={disabled ? () => {
    } : handleClick}>
      <div className={`rdw-option-wrapper ${disabled && 'rdw-option-disabled'}`} title="View History">
        <AccessTime
          style={{
            width: 16,
            height: 16,
            color: 'black',
          }}
        />
      </div>
    </div>
  );
};